<template>
  <div>
    <v-layout wrap>
      <v-flex xs12 sm3 class="form-control pa-1">
        <label for>{{ $t('uid') }}</label>
        <input
          v-model.lazy="filter.uid"
          type="text"
          :placeholder="$t('uid')"
          class="form-control"
          maxlength="255"
        />
      </v-flex>
      <v-flex xs12 sm3 class="form-control pa-1">
        <label for>{{ $t('line_name') }}</label>
        <input
          v-model.lazy="filter.line_name"
          type="text"
          :placeholder="$t('line_name')"
          class="form-control"
          maxlength="255"
        />
      </v-flex>
      <v-flex xs12 sm3 class="form-control pa-1">
        <label for>{{ $t('customer_name') }}</label>
        <input
          v-model.lazy="filter.th_name"
          type="text"
          :placeholder="$t('customer_name')"
          class="form-control"
          maxlength="255"
        />
      </v-flex>
      <v-flex xs12 sm3 class="form-control pa-1">
        <label for>{{ $t('account_no') }}</label>
        <input
          v-model.lazy="filter.account_no"
          type="text"
          :placeholder="$t('account_no')"
          class="form-control"
          maxlength="255"
        />
      </v-flex>
      <v-flex xs12 sm3 class="form-control pa-1">
        <label for>{{ $t('Id Card') }}</label>
        <input
          v-model.lazy="filter.id_no"
          type="text"
          :placeholder="$t('Id Card')"
          class="form-control"
          maxlength="255"
        />
      </v-flex>
      <v-flex xs12 sm3 class="form-control pa-1">
        <label for>{{ $t('card_no_amoney') }}</label>
        <input
          v-model.lazy="filter.card_no"
          type="text"
          :placeholder="$t('card_no_amoney')"
          class="form-control"
          maxlength="255"
        />
      </v-flex>

      <v-flex xs12 sm3 class="form-control pa-1">
        <label for>{{ $t('bank_name') }}</label>
        <input
          v-model.lazy="filter.bank_name"
          type="text"
          :placeholder="$t('bank_name')"
          class="form-control"
          maxlength="255"
        />
      </v-flex>

      <v-flex xs12 sm3 class="form-control pa-1">
        <label for>{{ $t('bank_account_no') }}</label>
        <input
          v-model.lazy="filter.bank_account_no"
          type="text"
          :placeholder="$t('bank_account_no')"
          class="form-control"
          maxlength="255"
        />
      </v-flex>

      <v-flex xs12 sm3 class="form-control pa-1">
        <label for>{{ $t('prompt_pay') }}</label>
        <input
          v-model.lazy="filter.prompt_pay"
          type="text"
          :placeholder="$t('prompt_pay')"
          class="form-control"
          maxlength="255"
        />
      </v-flex>

      <v-flex xs12 sm3 class="form-control pa-1">
        <label for>{{ $t('bank_account_status') }}</label>
        <multiselect
          v-model="filter.statusBankFilter"
          :options="statusBankOptions"
          label="label"
          select-label
          selected-label
          :allow-empty="false"
          :searchable="false"
          deselect-label
          track-by="label"
          @select="handleFilterBankStatus"
        ></multiselect>
      </v-flex>

      <v-flex xs12 sm3 class="form-control pa-1">
        <label for>{{ $t('Status') }}</label>
        <multiselect
          v-model="filter.statusFilter"
          :options="statusOptions"
          label="label"
          select-label
          selected-label
          :allow-empty="false"
          :searchable="false"
          deselect-label
          track-by="label"
          @select="handleFilterStatus"
        ></multiselect>
      </v-flex>
      <v-flex xs12 sm6 class="form-control pa-1">
        <div>
          <label for>{{ $t('regis_date') }}</label>
        </div>
        <v-layout>
          <v-flex class="px-1">
            <datepicker
              v-model="filter.registertimestamp_from"
              :placeholder="$t('from')"
              :clear-button="true"
              :clear-button-icon="'fas fa-times'"
              @selected="onRegisterStartDate"
            ></datepicker>
          </v-flex>
          <v-flex class="px-1">
            <datepicker
              v-model="filter.registertimestamp_to"
              style
              :placeholder="$t('to')"
              :clear-button="true"
              :clear-button-icon="'fas fa-times'"
              @selected="onRegisterEndDate"
            ></datepicker>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <slot name="append" :filter="filter"></slot>
    <div class="text-xs-right pa-1">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import config from '@/config'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'
import datepicker from 'vuejs-datepicker'

export default {
  components: {
    Multiselect,
    datepicker
  },
  props: {
    value: {
      default: undefined
    }
  },
  data: function () {
    return {
      payStatus: null,
      opt_in: null,
      allSchools: [],
      isLoading: false,
      filter: this.value,
      channelOptions: [],
      statusOptions: [
        {
          label: this.$t('All'),
          value: 'all'
        },
        {
          label: this.$t('ผูกบัญชี'),
          value: 'active'
        },
        {
          label: this.$t('ยกเลิกผูกบัญชี'),
          value: 'inactive'
        }
      ],
      statusBankOptions: [
        {
          label: this.$t('All'),
          value: 'all'
        },
        {
          label: this.$t('รอการตรวจสอบ'),
          value: 'waiting_to_approve'
        },
        {
          label: this.$t('เปิดใช้งาน'),
          value: 'active'
        }
      ],

      localeOptions: config.locale,

      intents: [],
      errorFilterTag: [],
      tag: '',
      sendNotiMember: false,
      daySendNoti: '',
      tagOptions: []
    }
  },

  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      userStatus: 'getUserStatus',
      loadingUserStatus: 'getLoadingUserStatus'
    })
  },
  watch: {
    value: function (newVal) {
      this.filter = newVal
    }
  },
  mounted: function () {},
  methods: {
    onRegisterStartDate: function (value) {
      if (moment(this.filter.registertimestamp_to).isBefore(value)) {
        this.filter.registertimestamp_to = value
      }
      this.filter.registertimestamp_from = value
      this.$emit('onUpdate')
    },
    onRegisterEndDate: function (value) {
      if (moment(value).isBefore(this.filter.registertimestamp_from)) {
        this.filter.registertimestamp_from = value
      }
      this.filter.registertimestamp_to = value
      this.$emit('onUpdate')
    },
    handleFilterStatus(param) {
      if (param && param.value == 'all') {
        this.filter.status = ''
      } else {
        this.filter.status = param.value
      }
      this.filter.statusFilter = param
    },
    handleFilterBankStatus(param) {
      if (param && param.value == 'all') {
        this.filter.bank_account_status = ''
      } else {
        this.filter.bank_account_status = param.value
      }
      this.filter.statusBankFilter = param
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/FilterMember.vue